import React from 'react';
import { useForm } from 'react-hook-form';
import {
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
  Alert,
} from '@mui/material';

const LoginForm = ({ onSubmit, loading, error }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: '',
      password: '',
    },
  });

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Typography variant="body2" sx={{ fontWeight: 600, color: '#212121', mb: 0.5 }}>
        Email
      </Typography>
      <TextField
        fullWidth
        id="username"
        placeholder="team@presidio.com"
        autoComplete="username"
        autoFocus
        {...register('username', {
          required: 'Email is required',
          minLength: {
            value: 3,
            message: 'Email must be at least 3 characters',
          },
        })}
        error={!!errors.username}
        helperText={errors.username?.message}
        sx={{
          mb: 2,
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            backgroundColor: '#FAFAFA',
          },
        }}
      />

      <Typography variant="body2" sx={{ fontWeight: 600, color: '#212121', mb: 0.5 }}>
        Password
      </Typography>
      <TextField
        fullWidth
        placeholder="Enter your password"
        type="password"
        id="password"
        autoComplete="current-password"
        {...register('password', {
          required: 'Password is required',
          minLength: {
            value: 4,
            message: 'Password must be at least 4 characters',
          },
        })}
        error={!!errors.password}
        helperText={errors.password?.message}
        sx={{
          mb: 2,
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            backgroundColor: '#FAFAFA',
          },
        }}
      />

      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={loading}
        sx={{
          mt: 1,
          py: 1.5,
          borderRadius: '10px',
          backgroundColor: '#2E7D32',
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '1rem',
          '&:hover': {
            backgroundColor: '#1B5E20',
          },
        }}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : 'Login'}
      </Button>
    </Box>
  );
};

export default LoginForm;
